module.exports = {
        srcSet: __webpack_public_path__ + "static/media/tenant_protection_mobile-800.ff3775a8.webp"+" 800w"+","+__webpack_public_path__ + "static/media/tenant_protection_mobile-960.c43d11b9.webp"+" 960w",
        images: [{path: __webpack_public_path__ + "static/media/tenant_protection_mobile-800.ff3775a8.webp",width: 800,height: 533},{path: __webpack_public_path__ + "static/media/tenant_protection_mobile-960.c43d11b9.webp",width: 960,height: 639}],
        src: __webpack_public_path__ + "static/media/tenant_protection_mobile-960.c43d11b9.webp",
        toString: function(){return __webpack_public_path__ + "static/media/tenant_protection_mobile-960.c43d11b9.webp"},
        
        width: 960,
        height: 639
      }